<script lang="ts" setup>

</script>
<template>
  <div class="c-region-resume-skeleton">
    <div class="illustration">
      <span class="skeleton" />
    </div>
    <div class="detail">
      <div class="content">
        <p class="title">
          <span class="skeleton" />
        </p>
        <p class="golfs">
          <span class="skeleton" />
        </p>
        <p class="description">
          <span class="skeleton" />
          <br>
          <span class="skeleton" />
          <span class="skeleton" />
          <span class="skeleton" />
        </p>
      </div>
    </div>
  </div>
</template>
<style scoped>

.c-region-resume-skeleton {
  display: flex;
  width: 100%;
  max-width: 1600px;
  flex-direction: column;
  margin: 3em auto;

  .illustration {
    display: flex;
    overflow: hidden;
    width: 100%;
    height: 30vh;
    align-items: center;
    justify-content: center;
  }

  .detail {
    .content {
      width: 100%;
      padding: 2.75em 3em;
      background: white;
      box-shadow: 0 0 25px rgb(0 0 0 / 26%);

      .title {
        width: 80%;
        height: 44px;
      }

      .golfs {
        width: 80px;
        height: 28px;
        margin: 1em 0;
      }

      .description {
        display: flex;
        flex-direction: column;

        span {
          margin-bottom: 0.25em;

          &:first-child {
            min-width: 75%;
            max-width: 75%;
          }

          &:last-child {
            min-width: 60%;
            max-width: 60%;
          }
        }
      }
    }
  }

  @media screen and (width >= 1024px) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);

    .illustration {
      height: auto;
      aspect-ratio: 3 / 2;
      grid-column: 1 / 8;
      grid-row: 1;
    }

    .detail {
      display: flex;
      grid-column: 6 / 13;
      grid-row: 1;

      .content {
        align-self: flex-end;
      }
    }
  }

  @media screen and (width >= 1280px) {
    .illustration {
      grid-column: 1 / 7;
    }

    .detail {
      grid-column: 5 / 13;

      .content {
        align-self: center;

        .description {
          display: flex;
        }
      }
    }
  }

  @media screen and (width >= 1600px) {
    .detail {
      grid-column: 6 / 13;

    }
  }

  .skeleton {
    display: flex;
    width: 100%;
    min-width: 100%;
    height: 100%;
    min-height: 20px;
    border-radius: 4px;
    animation: gradient-animation 3s ease infinite;
    background-image: linear-gradient(
      90deg,
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 5%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%),
      rgb(26 44 54 / 10%)
    );
    background-position: 100% 0;
    background-size: 400% 100%;

    @keyframes gradient-animation {
      0% {
        background-position: 100% 0;
      }

      100% {
        background-position: 0 100%;
      }
    }
  }
}
</style>
